import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const BasicIntroduction = () => {
  return (
    <section className="py-2 md:py-14 bg-white">
      <div className="container mx-auto px-4 md:px-6 w-full max-w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="order-2 md:order-1">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A2B4D] mb-6">
              🌟 Welcome to GlowHer.Life – Where Smart Living Meets Timeless
              Elegance
            </h2>

            <p className="text-[#1A2B4D]/80 mb-4">
              You are more than just a title—more than a career, a mother, a
              partner. You are a woman who deserves it all—success, beauty,
              balance, and a life well-lived.
            </p>

            <p className="text-[#1A2B4D]/80 mb-6">
              At GlowHer.Life, we believe in a world where women don't have to
              choose between ambition and self-care, between elegance and
              intelligence—you can have both.
            </p>

            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <span className="text-gold mr-2">✨</span>
                <span className="text-[#1A2B4D]/80">
                  Master the art of smart living—from finance and fashion to
                  wellness and family life.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-gold mr-2">✨</span>
                <span className="text-[#1A2B4D]/80">
                  Discover curated insights, expert guidance, and exclusive
                  deals tailored for modern, sophisticated women.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-gold mr-2">✨</span>
                <span className="text-[#1A2B4D]/80">
                  Join a thriving community that inspires, empowers, and
                  celebrates YOU.
                </span>
              </li>
            </ul>

            <p className="text-[#1A2B4D] font-medium italic mb-6">
              Because you don't just exist—you were made to shine.
            </p>

            <Link to="/about">
              <Button className="bg-[#1A2B4D] hover:bg-[#2E3F66] text-white group">
                <span>Explore More</span>
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
          </div>

          <div className="order-1 md:order-2">
            <img
              src="/images/11.png"
              alt="Người phụ nữ hiện đại tự tin trong một không gian thanh lịch"
              className="rounded-lg shadow-xl w-full h-auto object-cover"
            />
          </div>
        </div>

        {/* Phiên bản tiếng Việt */}
        {/* <div className="mt-16 border-t border-gray-200 pt-16 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="md:order-2">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A2B4D] mb-6">
              🌟 Chào mừng đến với GlowHer.Life – Nơi Cuộc Sống Thông Minh Gặp
              Gỡ Sự Thanh Lịch
            </h2>

            <p className="text-[#1A2B4D]/80 mb-4">
              Bạn không chỉ là một người vợ, một người mẹ, hay một người phụ nữ
              làm việc chăm chỉ. Bạn xứng đáng có tất cả—sự nghiệp, sắc đẹp, cân
              bằng và một cuộc sống đáng mơ ước.
            </p>

            <p className="text-[#1A2B4D]/80 mb-6">
              Tại GlowHer.Life, chúng tôi tin rằng phụ nữ không cần phải lựa
              chọn giữa sự nghiệp và chăm sóc bản thân, giữa trí tuệ và thanh
              lịch—bạn có thể có cả hai.
            </p>

            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <span className="text-gold mr-2">✨</span>
                <span className="text-[#1A2B4D]/80">
                  Làm chủ nghệ thuật sống thông minh—từ tài chính, thời trang,
                  sức khỏe đến cuộc sống gia đình.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-gold mr-2">✨</span>
                <span className="text-[#1A2B4D]/80">
                  Khám phá những nội dung đặc biệt, lời khuyên từ chuyên gia &
                  ưu đãi độc quyền dành riêng cho phụ nữ hiện đại.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-gold mr-2">✨</span>
                <span className="text-[#1A2B4D]/80">
                  Kết nối với một cộng đồng đầy cảm hứng, nơi tôn vinh, trao
                  quyền và nâng tầm giá trị của bạn.
                </span>
              </li>
            </ul>

            <p className="text-[#1A2B4D] font-medium italic mb-6">
              Vì bạn không chỉ tồn tại—bạn sinh ra để tỏa sáng.
            </p>

            <Link to="/about">
              <Button className="bg-[#1A2B4D] hover:bg-[#2E3F66] text-white group">
                <span>Khám Phá Ngay</span>
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
          </div>

          <div className="md:order-1">
            <img
              src="https://images.unsplash.com/photo-1516726817505-f5ed825624d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80"
              alt="Người phụ nữ hiện đại tự tin trong một không gian thanh lịch"
              className="rounded-lg shadow-xl w-full h-auto object-cover"
            />
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default BasicIntroduction;
